module.exports = __webpack_public_path__ + "static/media/3.da55e564.jpg";